'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RewindIcon = require('./RewindIcon');

var _RewindIcon2 = _interopRequireDefault(_RewindIcon);

var _windowPropType = require('../PropTypes/windowPropType');

var _windowPropType2 = _interopRequireDefault(_windowPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CamRewind = function CamRewind(_ref) {
  var href = _ref.href,
      text = _ref.text,
      isPremium = _ref.isPremium,
      spotId = _ref.spotId,
      legacySpotId = _ref.legacySpotId,
      spotName = _ref.spotName,
      window = _ref.window;

  var trackCamRewindClick = function trackCamRewindClick() {
    window.analytics.track('Clicked Cam Rewind', {
      spotId: spotId,
      legacySpotId: legacySpotId,
      spotName: spotName,
      ctaLocation: 'cam player'
    });
  };

  return _react2.default.createElement(
    'a',
    {
      href: href,
      onClick: !isPremium ? trackCamRewindClick : null,
      className: 'quiver-cam-rewind'
    },
    _react2.default.createElement(_RewindIcon2.default, null),
    _react2.default.createElement(
      'span',
      { className: 'quiver-cam-rewind__text' },
      text
    )
  );
};

CamRewind.propTypes = {
  href: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string,
  isPremium: _propTypes2.default.bool,
  spotId: _propTypes2.default.string,
  legacySpotId: _propTypes2.default.string,
  spotName: _propTypes2.default.string,
  window: _windowPropType2.default
};

CamRewind.defaultProps = {
  text: 'Cam Rewind',
  isPremium: true
};

exports.default = CamRewind;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamRewind/CamRewind.js
// module id = 541
// module chunks = 11